import React, { useState, useEffect, useContext,useCallback } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
// import CarnivalForm from './carnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const CreateFdTicket = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  saveFdTicket
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const inputs = {
      subject: '',
      description: '',
      priority: '',
      category: '',
      sub_category: ''
  };
  const [formData, setData] = useState(inputs);
  const [category, setCategory] = useState('');


  const handleSubmit = () => {
    if (formData.subject == '' || formData.description=='' || formData.priority=='' || formData.category=='' || formData.sub_category=='') {
      toast.error('Please fill all details!');
      return;
    } else {
      (async () => {
        setIsLoading(true);
        const res = await saveFdTicket(formData);
        setIsLoading(false);
        if (res) {
          setIsModal(true);
        } else {
          toast.error('Some error occurred. Please try again later.');
          return;
        }
      })();
    }
  };

  const handleModalHide2 = () => {
    history.push(`${baseUrl}/fd-tickets`);
  };

  const handleCategoryChange = (val) => {
    setCategory(val.id);
    setData({ ...formData, category: val.id });
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.createTickets}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.createFdTickets}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp`}
    >
        <FormSection title={localization.enterFdDetails}>
          <ConstantInput
            label={localization.subject}
            value={formData.subject}
            errorMsg={localization.requiredSubject}
            type="text"
            required
            handleChange={(value) => setData({ ...formData, subject: value })}
            isStarRequired={true}
          />
          <TextAreaInput
            inputValue={formData?.description}
            className={`${!formData.description && 'empty'} inline-css scrollbar-styling`}
            rows={4}
            type="text"
            label={localization.description}
            required
            isStarRequired={true}
            errorMsg={localization.isRequired}
            handleChange={(e) => setData({ ...formData, description: e.target.value })}
          />
          <DropDownInput
            label={localization.selectPriority}
            data={[
              {id: 1, name: "Low"},
              {id: 2,name: "Medium"},
              {id: 3,name: "High"},
              {id: 4,name: "Urgent"},
            ]}
            required
            isStarRequired={true}
            errorMsg={localization.enterField}
            getIdValue={(val) =>
              setData({ ...formData, priority: val.id })
            }
          />
          <DropDownInput
            label={localization.selectCategory}
            data={[
              {id: 'society', name: "Society"},
              {id: 'corporate',name: "Corporate"},
              // {id: 'mall',name: "Mall"} 
            ]}
            required
            isStarRequired={true}
            errorMsg={localization.enterField}
            getIdValue={(val) => handleCategoryChange(val)}
          />
          {category == "society" ?
            <DropDownInput
              label={localization.selectSubCategory}
              data={[
                {id: 'Tag not synced', name: "Tag not synced"},
                {id: "Barrier not opening",name: "Barrier not opening"},
                {id: "Flat details not getting added",name: "Flat details not getting added"},
                {id: "Helper details not getting added",name: "Helper details not getting added"},
                {id: "Not getting notifications on Mygate",name: "Not getting notifications on Mygate"},
                {id: "Mygate - Tag not getting activated",name: "Mygate - Tag not getting activated"},
                {id: "Notification issues on Park+ app",name: "Notification issues on Park+ app"},
                {id: "Insights dashboard login creation",name: "Insights dashboard login creation"},
                {id: "Gate level mapping",name: "Gate level mapping"},
                {id: "POS issues",name: "POS issues"},
                {id: "NFC card issues",name: "NFC card issues"},
                {id: "Pre-activated / mygate tag mapping",name: "Pre-activated / mygate tag mapping"},
                {id: "Unable to add resident RFID Tag",name: "Unable to add resident RFID Tag"},
                {id: "Others",name: "Others"},
                
              ]}
              required
              isStarRequired={true}
              errorMsg={localization.enterField}
              getIdValue={(val) => 
                setData({ ...formData, sub_category: val.id })
              }
            />
            : null
          }
          {category == "corporate" ?
            <DropDownInput
              label={localization.selectSubCategory}
              data={[
                {id: "Add an organization/tenant to project", name: "Add an organization/tenant to project"},
                {id: "Login credentials for user tenant", name: "Login credentials for user tenant"},
                {id: "User creation/deletion via user access dashboard", name: "User creation/deletion via user access dashboard"},
                {id: "Export report mismatch", name: "Export report mismatch"},
                {id: "Cloud action failure/not recieve", name: "Cloud action failure/not recieve"},
                {id: "Slot updation", name: "Slot updation"},
                {id: "VMS issue", name: "VMS issue"},
                {id: "POS issue", name: "POS issue"},
                {id: "Tags not working", name: "Tags not working"},
                {id: "Auto check exit issue", name: "Auto check exit issue"},
                {id: "Others", name: "Others"},
                
              ]}
              required
              isStarRequired={true}
              errorMsg={localization.enterField}
              getIdValue={(val) => 
                setData({ ...formData, sub_category: val.id })
              }
            />
            : null
          }
          {/* {category == "mall" ?
            <DropDownInput
              label={localization.selectSubCategory}
              data={[
                {id: "Add an organization/tenant to project", name: "Add an organization/tenant to project"},
                {id: "Login credentials for user tenant", name: "Login credentials for user tenant"},
                {id: "User creation/deletion via user access dashboard", name: "User creation/deletion via user access dashboard"}                
              ]}
              required
              isStarRequired={true}
              errorMsg={localization.enterField}
              getIdValue={(val) => 
                setData({ ...formData, sub_category: val.id })http://localhost:3000/dashboard/createSiteInpectionForm/10142
              }
            />
            : null
          } */}
          {<FileUpload
              id={"addAttachment"}
              accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.xlsx,.xls"
              documentUploadUrl={documentUploadUrlPublic}
              documentUrlData={documentUrlDataPublic}
              onChange={(val) =>
                setData({ ...formData, images: val })
              }
              multiple
              >
              <span className="btn btn-transparent">
                  {localization.media}
              </span>
          </FileUpload>}
        </FormSection>
        <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={handleModalHide2}
            keyboard
            backdrop
        >
            <div className="text-center">
            <div className="success">
                <img src={Images?.tick} alt="" />
            </div>
            <h5>{localization.fdCreatedSuccess}</h5>
            <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
                {localization.goToFdListing}{' '}
                <img src={Images?.ArrowRight} alt="" />
            </Button>
            </div>
        </ModalPop>
    </Layout>
  );
};

CreateFdTicket.propTypes = {};

export default CreateFdTicket;
